module.exports = ({
    "CDMS200H001": "No.",
    "CDMS200H002": "Study ID",
    "CDMS200H003": "Study Name",
    "CDMS200H004": "Role",
    "CDMS200H005": "Protocol No."
});